<template>
  <ValidationObserver ref="observer" class="transition duration-500 ease-in-out transform w-full"
                      style="transition: all 1s !important"
                      tag="form" @submit.prevent="submit()">

    <div>
      <v-card flat>
        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">CPD
              Activity</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select v-model="formValues.cpdActivityId" :clearable="true" :elevation="1" :items="CATEGORIES"
                        :loading="cpdActLoading" dense hint="Select cpd activity" item-text="name" item-value="id"
                        solo @change="categoryChanged($event)">
              </v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div v-if="COURSES.length !== 0" class="w-full md:w-1/2 px-3 mb-6">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Course(Category
              1)</label>
            <v-autocomplete
                v-model="formValues.course"
                :clearable="true" :item-text="item => item.course.courseName" :items="COURSES" :loading="courseLoading"
                :searchable="true"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                hint="Select course" item-value="id" persistent-hint
                return-object>
            </v-autocomplete>

            <br/>
          </div>
          <div v-else-if="CATEGORY2_COURSES.length !== 0" class="w-full md:w-1/2 px-3 mb-6">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Course(Category
              2)</label>
            <v-autocomplete
                v-model="formValues.category2Course"
                :clearable="true" :item-text="item => item.courseTitleCat2" :items="CATEGORY2_COURSES"
                :loading="courseLoading" :searchable="true"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                hint="Select course" item-value="id" persistent-hint>
            </v-autocomplete>
          </div>
          <div v-else class="pl-4 m-auto">
            <p class="grey--text" style="border: 1px solid lightblue; padding: 5px;">
              <v-icon class="mr-1" left style="color: #1976d2">mdi-information-variant</v-icon>
              No courses to display until cpd activity selected.
            </p>
          </div>
          <div class="flex flex-wrap my-6 mx-6 mb-6">
            <div class="w-full">
              <button
                  class="float-right shadow bg-teal-600 hover:bg-teal-600 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="button"
                  @click="submit()">
                Assign Trainer
              </button>
            </div>
            <div class="md:w-2/3"></div>
          </div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import {getCategories, getProgramsLite} from "@/utils/helper";

extend("required", {
  ...required,
  message: "This field is required",
});

export default {
  props: {
    trainer: Object
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      CATEGORIES: [],
      selectedCategory: null,
      cpdActLoading: false,
      courseLoading: false,
      CPD_ACTIVITIES: [],
      formValues: {
        cpdActivityId: null,
        course: null,
        category2Course: null,
        assigningCourse: true,
        editMode: false,
        previousCourseId: null,
        previousCourseCategory: null
      },
      COURSES: [],
      CATEGORY2_COURSES: [],
      cpdActivityChangeCount: 0,
      trainerDetail: {}
    }
  },
  async created() {
    await this.initLookups();
    if (this.trainer != null) {
      this.formValues.editMode = true;
      this.trainerDetail = this.trainer;
      this.formValues.previousCourseId = this.trainerDetail?.id;
      this.formValues.previousCourseCategory = this.trainerDetail?.program?.category?.categoryType;
      this.formValues.cpdActivityId = this.trainerDetail?.program?.categoryId;
      this.categoryChanged(this.trainerDetail)
    }
  },
  methods: {
    async initLookups() {
      this.cpdActLoading = true;
      this.CATEGORIES = await getCategories();
      const cpdActRes = await getProgramsLite();
      this.CPD_ACTIVITIES = cpdActRes.data?.rows ? cpdActRes.data.rows : null;
      this.cpdActLoading = false;
    },
    categoryChanged(event) {
      this.courseLoading = true;
      const courses = [];
      const category2Courses = [];
      this.formValues.course = null;
      this.formValues.category2Course = null;
      const theCategory = event.program ? event.program.categoryId : event;
      this.CPD_ACTIVITIES?.forEach((program) => {
        if (theCategory == program.categoryId) {
          if (program.category?.categoryType == "CAT1") {
            const startDate = program?.startDate;
            const endDate = program?.endDate;
            const programCourses = program.program_courses;
            for (let index = 0; index < programCourses.length; index++) {
              const element = programCourses[index];
              element.course ? element.course.courseName = `${element.course?.courseName} (${startDate} - ${endDate})` : null;
              courses.push(element);
            }
          } else {
            const startDate = program?.startDate;
            const endDate = program?.endDate;
            program.courseTitleCat2 = `${program.courseTitleCat2} (${startDate} - ${endDate})`
            category2Courses.push(program);
          }
        }
      });

      this.COURSES = courses ? courses : null;
      this.CATEGORY2_COURSES = category2Courses ? category2Courses : null;

      if (
          this.formValues.editMode == true &&
          this.cpdActivityChangeCount == 0
      ) {
        if (event.course) {
          this.formValues.course = event;
          this.formValues.category2Course = null;
        } else {
          this.formValues.category2Course = event.programId;
          this.formValues.course = null;
        }
      }

      this.courseLoading = false;
      this.cpdActivityChangeCount += 1;
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("saveAssignedCourse", this.formValues)
    }
  }
}
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
